import { connect } from "react-redux";
import { closeModal } from "../../../../../../../store/action/modalAction";
import { getTemporaryBlockId } from "../../../../../../../services/helpers/Helper";

const ListBlocks = (props) => {
   const { closeModal, data, faqId, handleChangeButton, index } = props;
   let { buttons } = props;

   const getListBlocks = () => {
      const { blocks, first_block } = data;
      let listBlocks = blocks.filter(f => !f.is_hidden && getTemporaryBlockId(f) !== faqId);
      if (getTemporaryBlockId(first_block) !== faqId) {
         listBlocks.push(first_block);
      }
      return listBlocks;
   }

   const handleSelectBlock = (block) => {
      if (handleChangeButton) {
         buttons = buttons.map((button, i) => i === index ? {
            ...button, action: {
               type: "block",
               value: "",
               block_id: getTemporaryBlockId(block),
            }
         } : button);

         handleChangeButton(buttons);
         closeModal();
      }
   }
   return (
      <div className="existing-popup-container is_opening">
         <div className="popup-overlay" onClick={closeModal}></div>
         <div className="popup-wrapper message-flow-popup popup-select-cms_content-wrapper">
            <div className="popup-content-wrapper">
               <div className="popup-btn-close" onClick={closeModal}>
                  <svg viewBox="0 0 32 32">
                     <path
                        d="M18.263 16l10.07-10.07c.625-.625.625-1.636 0-2.26s-1.638-.627-2.263 0L16 13.737 5.933 3.667c-.626-.624-1.637-.624-2.262 0s-.624 1.64 0 2.264L13.74 16 3.67 26.07c-.626.625-.626 1.636 0 2.26.312.313.722.47 1.13.47s.82-.157 1.132-.47l10.07-10.068 10.068 10.07c.312.31.722.468 1.13.468s.82-.157 1.132-.47c.626-.625.626-1.636 0-2.26L18.262 16z">
                     </path>
                  </svg>
               </div>
               <div className="popup-select-cms_content-main-content">
                  <div className="popup-select-cms_content-header">
                     <h3>Chọn một tin nhắn</h3>
                  </div>
                  <div className="popup-select-cms_content-content existing-step-popup">
                     <div className="width100">
                        {getListBlocks().map((block, index) => (
                           <div className="existing-step pointer" key={index} onClick={() => handleSelectBlock(block)}>
                              <span>
                                 <div className="svg-next-icon next-icon-comment-lines">
                                 </div>
                              </span>
                              <a className="existing-step__title">{block.title}</a>
                           </div>
                        ))}
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}
const mapStateToProps = () => {
   return {

   }
}
export default connect(mapStateToProps, {
   closeModal
})(ListBlocks);